/// <reference path="../../../../typings/globals/jquery/index.d.ts" />
/**
 * Rozszerzenia/modyfikacje komponentów Boostrap.
 *
 * @class PopoverExtension
 * @extends {DropdownExtension}
 */

import { DropdownExtension } from "./DropdownExtension.class"
import { SimpleCart } from "../cart/SimpleCart.class";

export class PopoverExtension extends DropdownExtension {
	constructor(options) {
		super(options);
		var defaultSettings = {
			selector: '.addPopover',
			trigger: 'manual',
			placement: 'bottom',
			html: true,
			template: '<div class="popover popoverCustom" role="tooltip"><div class="arrow"></div><h3 class="popover-header clearfix"></h3><div class="popover-body"></div></div>',
			content: function () {
				return $($(this).data('custom-content')).children('.popover-custom-body').html();
			},
			title: function () {
				return $($(this).data('custom-content')).children('.popover-custom-title').html();
			},
			boundary: 'window',
			fixPosition: false,
			displayDelay: 200,
			lifeTime: POPOVER_LIFE_TIME
		};
		this.popoverSettings = $.extend({}, defaultSettings, options);
		this.displayDelayTimer = null;
		this.closeTimer = null;
		this.cart = new SimpleCart();
	}
	// ****************************************************************************************************
	// Inicjalizacja Popovers
	// ****************************************************************************************************
	initPopovers(options) {
		var that = this;
		var opt = $.extend({}, that.popoverSettings, options);
		if (opt.fixPosition) {
			that.fixPopoverPosition(opt.selector);
		}
		$(opt.selector).popover('dispose').popover({
			trigger: opt.trigger,
			placement: opt.placement,
			html: opt.html,
			template: opt.template,
			content: opt.content,
			title: opt.title,
			boundary: opt.boundary
		}).on('show.bs.popover', function () {
			//This event fires immediately when the show instance method is called.
		}).on('inserted.bs.popover', function () {
			//This event is fired after the show.bs.popover event when the popover template has been added to the DOM.
			// uaktualnienie zawartości simple
			if (this.id == 'cartBtn') {
				that.cart.loadSimpleCartContent();
			}
			if (this.id == 'clipboardBtn') {
				that.cart.loadSimpleClipboardContent();
			}
		}).on('shown.bs.popover', function () {
			//This event is fired when the popover has been made visible to the user (will wait for CSS transitions to complete).
			$('.popover-header .popoverCloseBtn').on('click', function () {
				that.closePopover($('#' + $(this).data('close-target')));
			});
		}).on('mouseenter', function () {
			that.closeAllPopovers(this, opt.selector);
			clearTimeout(that.displayDelayTimer);
			that.displayDelayTimer = setTimeout(function () {
				that.openPopover(this);
				$(this).data('block-click', 'true');
				setTimeout(function () {
					$(this).removeData('block-click');
				}.bind(this), 500);
			}.bind(this), opt.displayDelay);
		}).on('mouseleave', function () {
			clearTimeout(that.displayDelayTimer);
			that.preparePopoverToClose(this, opt.lifeTime);
		}).on('click', function (event) {
			var triggeredEl = $(this);
			event.stopPropagation();
			if (triggeredEl.hasClass('popoverShown')) {
				if (triggeredEl.data('block-click') != 'true') {
					that.closePopover(triggeredEl); //triggeredEl.trigger('mouseleave');
				}
			} else {
				triggeredEl.trigger('mouseenter');
			}
		});
		//console.log('initPopover', opt);
	}
	// ****************************************************************************************************
	// Zamykanie wszystkich otwartych Popovers
	// ****************************************************************************************************
	closeAllPopovers(obj_this, selector) {
		//console.log('closeAllPopovers', selector);
		var that = this;
		var triggeredEl = $(obj_this);
		$(selector).each(function (i, e) {
			if ($(e).attr('id') != triggeredEl.attr('id') && $(e).hasClass('popoverShown'))
				that.closePopover($(e));
		});
	}
	// ****************************************************************************************************
	// Otwieranie Popover
	// ****************************************************************************************************
	openPopover(obj_this) {
		//console.log('openPopover');
		var that = this;
		var triggeredEl = $(obj_this);
		var readyToCloseClass = triggeredEl.data('popover-id');

		if (readyToCloseClass != '0')
			triggeredEl.removeClass('popoverReadyToClose' + readyToCloseClass).data('popover-id', 0);
		if (!triggeredEl.hasClass('popoverShown')) {
			triggeredEl.addClass('popoverShown').popover('show');
			// wywalić to poniżej - init musi miec inny template dla navi
			if (triggeredEl.attr('data-navi-element') == 'true')
				$('#' + triggeredEl.attr('aria-describedby')).addClass('popoverNavi');
		}
	}
	// ****************************************************************************************************
	// Przygotowanie Popover do zamkniecia
	// ****************************************************************************************************
	preparePopoverToClose(obj_this, lifeTime) {
		//console.log('preparePopoverToClose', lifeTime, obj_this);
		var that = this;
		var triggeredEl = $(obj_this);
		if (triggeredEl.hasClass('popoverShown')) {
			var rand = Math.floor(Math.random() * 1000000);
			var readyToCloseClass = triggeredEl.data('popover-id');
			if (readyToCloseClass == '0') {
				that.closeTimer = setTimeout(function () {
					if (triggeredEl.hasClass('popoverReadyToClose' + rand))
						that.closePopover(triggeredEl, rand);
				}, lifeTime);
				triggeredEl.addClass('popoverReadyToClose' + rand).data('popover-id', rand);
			}
			var popover = triggeredEl.attr('aria-describedby');
			$('#' + popover).on('mouseenter', function () {
				//console.log('popover mouseenter' );
				clearTimeout(that.closeTimer);
				triggeredEl.removeClass('popoverReadyToClose' + rand).data('popover-id', 0);
			}).on('mouseleave', function () {
				//console.log('popover mouseleave' );
				triggeredEl.trigger('mouseleave');
			});
		}
	}
	// ****************************************************************************************************
	// Zamykanie Popover
	// ****************************************************************************************************
	closePopover(popover, id) {
		if (id == undefined)
			id = popover.data('popover-id');
		popover.removeClass('popoverShown').removeClass('popoverReadyToClose' + id).data('popover-id', 0).popover('hide');
	}
	// ****************************************************************************************************
	// Centrowanie Popover
	// ****************************************************************************************************
	fixPopoverPosition(selector) {
		var that = this;
		var screenCenter = $(document).width() / 2;
		var margBody = ($(document).width() - toolsObj.realWidth($('#navi'))) / 2;
		var margNavi = (toolsObj.realWidth($('#navi')) - toolsObj.realWidth($('.navbarDesktop').first())) / 2;
		var prevBtnsWidth = 0;
		$(selector).each(function (i, e) {
			var realW = toolsObj.realWidth($(e));
			var btnXfromEdge = margBody + margNavi + prevBtnsWidth + (realW / 2) - 1;
			prevBtnsWidth += realW;
			$(e).data('offset', (screenCenter - btnXfromEdge - 1)); // Math.floor
		});
	}
}
